// Auto-generated from Foundry artifacts — DO NOT EDIT
// Source: packages/vault/contracts/out/AgentVaultCore.sol/AgentVaultCore.json

export const AGENT_VAULT_CORE_ABI = [
  {
    type: "constructor",
    inputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "allowance",
    inputs: [
      {
        name: "owner",
        type: "address",
        internalType: "address",
      },
      {
        name: "spender",
        type: "address",
        internalType: "address",
      },
    ],
    outputs: [
      {
        name: "",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "approve",
    inputs: [
      {
        name: "spender",
        type: "address",
        internalType: "address",
      },
      {
        name: "value",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    outputs: [
      {
        name: "",
        type: "bool",
        internalType: "bool",
      },
    ],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "asset",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "address",
        internalType: "address",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "balanceOf",
    inputs: [
      {
        name: "account",
        type: "address",
        internalType: "address",
      },
    ],
    outputs: [
      {
        name: "",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "convertToAssets",
    inputs: [
      {
        name: "shares",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    outputs: [
      {
        name: "",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "convertToShares",
    inputs: [
      {
        name: "assets",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    outputs: [
      {
        name: "",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "creatorAgentId",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "decimals",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "uint8",
        internalType: "uint8",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "deposit",
    inputs: [
      {
        name: "assets",
        type: "uint256",
        internalType: "uint256",
      },
      {
        name: "receiver",
        type: "address",
        internalType: "address",
      },
    ],
    outputs: [
      {
        name: "",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "deposit",
    inputs: [
      {
        name: "agentId",
        type: "uint256",
        internalType: "uint256",
      },
      {
        name: "assets",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    outputs: [
      {
        name: "shares",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "feeModule",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "address",
        internalType: "contract IFeeModule",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "identityAdapter",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "address",
        internalType: "contract IIdentityRegistryAdapter",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "identityGated",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "bool",
        internalType: "bool",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "initialize",
    inputs: [
      {
        name: "config",
        type: "tuple",
        internalType: "struct VaultConfig",
        components: [
          {
            name: "baseAsset",
            type: "address",
            internalType: "address",
          },
          {
            name: "creatorAgentId",
            type: "uint256",
            internalType: "uint256",
          },
          {
            name: "managementFeeBps",
            type: "uint16",
            internalType: "uint16",
          },
          {
            name: "performanceFeeBps",
            type: "uint16",
            internalType: "uint16",
          },
          {
            name: "identityGated",
            type: "bool",
            internalType: "bool",
          },
          {
            name: "metadataURI",
            type: "string",
            internalType: "string",
          },
          {
            name: "disclosure",
            type: "tuple",
            internalType: "struct VaultDisclosure",
            components: [
              {
                name: "strategyDescription",
                type: "string",
                internalType: "string",
              },
              {
                name: "strategyHash",
                type: "bytes32",
                internalType: "bytes32",
              },
              {
                name: "riskRating",
                type: "uint8",
                internalType: "uint8",
              },
              {
                name: "disclaimerURI",
                type: "string",
                internalType: "string",
              },
            ],
          },
        ],
      },
      {
        name: "_identityAdapter",
        type: "address",
        internalType: "address",
      },
      {
        name: "_feeModule",
        type: "address",
        internalType: "address",
      },
    ],
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "maxDeposit",
    inputs: [
      {
        name: "",
        type: "address",
        internalType: "address",
      },
    ],
    outputs: [
      {
        name: "",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "maxMint",
    inputs: [
      {
        name: "",
        type: "address",
        internalType: "address",
      },
    ],
    outputs: [
      {
        name: "",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "maxRedeem",
    inputs: [
      {
        name: "owner",
        type: "address",
        internalType: "address",
      },
    ],
    outputs: [
      {
        name: "",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "maxWithdraw",
    inputs: [
      {
        name: "owner",
        type: "address",
        internalType: "address",
      },
    ],
    outputs: [
      {
        name: "",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "mint",
    inputs: [
      {
        name: "shares",
        type: "uint256",
        internalType: "uint256",
      },
      {
        name: "receiver",
        type: "address",
        internalType: "address",
      },
    ],
    outputs: [
      {
        name: "",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "name",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "string",
        internalType: "string",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "owner",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "address",
        internalType: "address",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "pause",
    inputs: [],
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "paused",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "bool",
        internalType: "bool",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "previewDeposit",
    inputs: [
      {
        name: "assets",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    outputs: [
      {
        name: "",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "previewMint",
    inputs: [
      {
        name: "shares",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    outputs: [
      {
        name: "",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "previewRedeem",
    inputs: [
      {
        name: "shares",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    outputs: [
      {
        name: "",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "previewWithdraw",
    inputs: [
      {
        name: "assets",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    outputs: [
      {
        name: "",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "redeem",
    inputs: [
      {
        name: "shares",
        type: "uint256",
        internalType: "uint256",
      },
      {
        name: "receiver",
        type: "address",
        internalType: "address",
      },
      {
        name: "_owner",
        type: "address",
        internalType: "address",
      },
    ],
    outputs: [
      {
        name: "",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "renounceOwnership",
    inputs: [],
    outputs: [],
    stateMutability: "pure",
  },
  {
    type: "function",
    name: "symbol",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "string",
        internalType: "string",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "totalAssets",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "totalSupply",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "transfer",
    inputs: [
      {
        name: "to",
        type: "address",
        internalType: "address",
      },
      {
        name: "value",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    outputs: [
      {
        name: "",
        type: "bool",
        internalType: "bool",
      },
    ],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "transferFrom",
    inputs: [
      {
        name: "from",
        type: "address",
        internalType: "address",
      },
      {
        name: "to",
        type: "address",
        internalType: "address",
      },
      {
        name: "value",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    outputs: [
      {
        name: "",
        type: "bool",
        internalType: "bool",
      },
    ],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "transferOwnership",
    inputs: [
      {
        name: "newOwner",
        type: "address",
        internalType: "address",
      },
    ],
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "unpause",
    inputs: [],
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "vaultCapabilities",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "uint8",
        internalType: "uint8",
      },
    ],
    stateMutability: "pure",
  },
  {
    type: "function",
    name: "withdraw",
    inputs: [
      {
        name: "assets",
        type: "uint256",
        internalType: "uint256",
      },
      {
        name: "receiver",
        type: "address",
        internalType: "address",
      },
      {
        name: "_owner",
        type: "address",
        internalType: "address",
      },
    ],
    outputs: [
      {
        name: "",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    stateMutability: "nonpayable",
  },
  {
    type: "event",
    name: "AgentDeposit",
    inputs: [
      {
        name: "agentId",
        type: "uint256",
        indexed: true,
        internalType: "uint256",
      },
      {
        name: "assets",
        type: "uint256",
        indexed: false,
        internalType: "uint256",
      },
      {
        name: "shares",
        type: "uint256",
        indexed: false,
        internalType: "uint256",
      },
    ],
    anonymous: false,
  },
  {
    type: "event",
    name: "Approval",
    inputs: [
      {
        name: "owner",
        type: "address",
        indexed: true,
        internalType: "address",
      },
      {
        name: "spender",
        type: "address",
        indexed: true,
        internalType: "address",
      },
      {
        name: "value",
        type: "uint256",
        indexed: false,
        internalType: "uint256",
      },
    ],
    anonymous: false,
  },
  {
    type: "event",
    name: "Deposit",
    inputs: [
      {
        name: "sender",
        type: "address",
        indexed: true,
        internalType: "address",
      },
      {
        name: "owner",
        type: "address",
        indexed: true,
        internalType: "address",
      },
      {
        name: "assets",
        type: "uint256",
        indexed: false,
        internalType: "uint256",
      },
      {
        name: "shares",
        type: "uint256",
        indexed: false,
        internalType: "uint256",
      },
    ],
    anonymous: false,
  },
  {
    type: "event",
    name: "Initialized",
    inputs: [
      {
        name: "version",
        type: "uint64",
        indexed: false,
        internalType: "uint64",
      },
    ],
    anonymous: false,
  },
  {
    type: "event",
    name: "OwnershipTransferred",
    inputs: [
      {
        name: "previousOwner",
        type: "address",
        indexed: true,
        internalType: "address",
      },
      {
        name: "newOwner",
        type: "address",
        indexed: true,
        internalType: "address",
      },
    ],
    anonymous: false,
  },
  {
    type: "event",
    name: "Paused",
    inputs: [
      {
        name: "account",
        type: "address",
        indexed: false,
        internalType: "address",
      },
    ],
    anonymous: false,
  },
  {
    type: "event",
    name: "Transfer",
    inputs: [
      {
        name: "from",
        type: "address",
        indexed: true,
        internalType: "address",
      },
      {
        name: "to",
        type: "address",
        indexed: true,
        internalType: "address",
      },
      {
        name: "value",
        type: "uint256",
        indexed: false,
        internalType: "uint256",
      },
    ],
    anonymous: false,
  },
  {
    type: "event",
    name: "Unpaused",
    inputs: [
      {
        name: "account",
        type: "address",
        indexed: false,
        internalType: "address",
      },
    ],
    anonymous: false,
  },
  {
    type: "event",
    name: "Withdraw",
    inputs: [
      {
        name: "sender",
        type: "address",
        indexed: true,
        internalType: "address",
      },
      {
        name: "receiver",
        type: "address",
        indexed: true,
        internalType: "address",
      },
      {
        name: "owner",
        type: "address",
        indexed: true,
        internalType: "address",
      },
      {
        name: "assets",
        type: "uint256",
        indexed: false,
        internalType: "uint256",
      },
      {
        name: "shares",
        type: "uint256",
        indexed: false,
        internalType: "uint256",
      },
    ],
    anonymous: false,
  },
  {
    type: "error",
    name: "ERC20InsufficientAllowance",
    inputs: [
      {
        name: "spender",
        type: "address",
        internalType: "address",
      },
      {
        name: "allowance",
        type: "uint256",
        internalType: "uint256",
      },
      {
        name: "needed",
        type: "uint256",
        internalType: "uint256",
      },
    ],
  },
  {
    type: "error",
    name: "ERC20InsufficientBalance",
    inputs: [
      {
        name: "sender",
        type: "address",
        internalType: "address",
      },
      {
        name: "balance",
        type: "uint256",
        internalType: "uint256",
      },
      {
        name: "needed",
        type: "uint256",
        internalType: "uint256",
      },
    ],
  },
  {
    type: "error",
    name: "ERC20InvalidApprover",
    inputs: [
      {
        name: "approver",
        type: "address",
        internalType: "address",
      },
    ],
  },
  {
    type: "error",
    name: "ERC20InvalidReceiver",
    inputs: [
      {
        name: "receiver",
        type: "address",
        internalType: "address",
      },
    ],
  },
  {
    type: "error",
    name: "ERC20InvalidSender",
    inputs: [
      {
        name: "sender",
        type: "address",
        internalType: "address",
      },
    ],
  },
  {
    type: "error",
    name: "ERC20InvalidSpender",
    inputs: [
      {
        name: "spender",
        type: "address",
        internalType: "address",
      },
    ],
  },
  {
    type: "error",
    name: "ERC4626ExceededMaxDeposit",
    inputs: [
      {
        name: "receiver",
        type: "address",
        internalType: "address",
      },
      {
        name: "assets",
        type: "uint256",
        internalType: "uint256",
      },
      {
        name: "max",
        type: "uint256",
        internalType: "uint256",
      },
    ],
  },
  {
    type: "error",
    name: "ERC4626ExceededMaxMint",
    inputs: [
      {
        name: "receiver",
        type: "address",
        internalType: "address",
      },
      {
        name: "shares",
        type: "uint256",
        internalType: "uint256",
      },
      {
        name: "max",
        type: "uint256",
        internalType: "uint256",
      },
    ],
  },
  {
    type: "error",
    name: "ERC4626ExceededMaxRedeem",
    inputs: [
      {
        name: "owner",
        type: "address",
        internalType: "address",
      },
      {
        name: "shares",
        type: "uint256",
        internalType: "uint256",
      },
      {
        name: "max",
        type: "uint256",
        internalType: "uint256",
      },
    ],
  },
  {
    type: "error",
    name: "ERC4626ExceededMaxWithdraw",
    inputs: [
      {
        name: "owner",
        type: "address",
        internalType: "address",
      },
      {
        name: "assets",
        type: "uint256",
        internalType: "uint256",
      },
      {
        name: "max",
        type: "uint256",
        internalType: "uint256",
      },
    ],
  },
  {
    type: "error",
    name: "EnforcedPause",
    inputs: [],
  },
  {
    type: "error",
    name: "ExpectedPause",
    inputs: [],
  },
  {
    type: "error",
    name: "InvalidAgent",
    inputs: [],
  },
  {
    type: "error",
    name: "InvalidInitialization",
    inputs: [],
  },
  {
    type: "error",
    name: "NotAgentWallet",
    inputs: [],
  },
  {
    type: "error",
    name: "NotInitializing",
    inputs: [],
  },
  {
    type: "error",
    name: "OwnableInvalidOwner",
    inputs: [
      {
        name: "owner",
        type: "address",
        internalType: "address",
      },
    ],
  },
  {
    type: "error",
    name: "OwnableUnauthorizedAccount",
    inputs: [
      {
        name: "account",
        type: "address",
        internalType: "address",
      },
    ],
  },
  {
    type: "error",
    name: "ReentrancyGuardReentrantCall",
    inputs: [],
  },
  {
    type: "error",
    name: "SafeERC20FailedOperation",
    inputs: [
      {
        name: "token",
        type: "address",
        internalType: "address",
      },
    ],
  },
  {
    type: "error",
    name: "ZeroAssets",
    inputs: [],
  },
  {
    type: "error",
    name: "ZeroShares",
    inputs: [],
  },
] as const;

export const AGENT_VAULT_CORE_BYTECODE =
  "0x608060405234801561000f575f80fd5b5060017f9b779b17422d0df92223018b32b4d1fa46e071723d6817e2486d003becc55f005561003c610041565b6100f3565b7ff0c57e16840df040f15088dc2f81fe391c3923bec73e23a9662efc9c229c6a00805468010000000000000000900460ff16156100915760405163f92ee8a960e01b815260040160405180910390fd5b80546001600160401b03908116146100f05780546001600160401b0319166001600160401b0390811782556040519081527fc7f505b2f371ae2175ee4913f4499e1f2633a7b5936321eed1cdaeb6115181d29060200160405180910390a15b50565b612248806101005f395ff3fe608060405234801561000f575f80fd5b5060043610610229575f3560e01c80638da5cb5b1161012a578063c3c82537116100b4578063d905777e11610079578063d905777e14610473578063dd62ed3e14610486578063e2bbb15814610499578063ef8b30f71461043a578063f2fde38b146104ac575f80fd5b8063c3c825371461042d578063c63d75b61461032c578063c6e6f5921461043a578063ce96cb771461044d578063d583fbc414610460575f80fd5b8063b1afa729116100fa578063b1afa729146103c9578063b3d7f6b9146103e1578063b460af94146103f4578063ba08765214610407578063bae41cbf1461041a575f80fd5b80638da5cb5b1461039357806394bf804d1461039b57806395d89b41146103ae578063a9059cbb146103b6575f80fd5b806338d52e0f116101b65780635f99088d1161017b5780635f99088d146103565780636e553f651461035d57806370a0823114610370578063715018a6146103835780638456cb591461038b575f80fd5b806338d52e0f146103025780633f4ba83a14610322578063402d267d1461032c5780634cdad506146102655780635c975abb1461033f575f80fd5b8063095ea7b3116101fc578063095ea7b3146102785780630a28a4771461029b57806318160ddd146102ae57806323b872dd146102d5578063313ce567146102e8575f80fd5b806301e1d1141461022d578063061114351461024857806306fdde031461025057806307a2d13a14610265575b5f80fd5b6102356104bf565b6040519081526020015b60405180910390f35b6102355f5481565b610258610535565b60405161023f9190611c19565b610235610273366004611c4e565b6105f5565b61028b610286366004611c79565b610606565b604051901515815260200161023f565b6102356102a9366004611c4e565b61061d565b7f52c63247e1f47db19d5ce0460030c497f067ca4cebf71ba98eeadabe20bace0254610235565b61028b6102e3366004611ca3565b610629565b6102f061064e565b60405160ff909116815260200161023f565b61030a610691565b6040516001600160a01b03909116815260200161023f565b61032a6106c5565b005b61023561033a366004611ce1565b6106d7565b5f805160206121d38339815191525460ff1661028b565b60036102f0565b61023561036b366004611cfc565b610711565b61023561037e366004611ce1565b61073c565b61032a610762565b61032a6107af565b61030a6107bf565b6102356103a9366004611cfc565b6107e7565b6102586107fa565b61028b6103c4366004611c79565b610838565b60015461030a9061010090046001600160a01b031681565b6102356103ef366004611c4e565b610845565b610235610402366004611d2a565b610851565b610235610415366004611d2a565b61087d565b60025461030a906001600160a01b031681565b60015461028b9060ff1681565b610235610448366004611c4e565b610891565b61023561045b366004611ce1565b61089c565b61032a61046e366004611d69565b6108a9565b610235610481366004611ce1565b610ae5565b610235610494366004611db2565b610aef565b6102356104a7366004611dde565b610b38565b61032a6104ba366004611ce1565b610cf6565b5f6104c8610691565b6040516370a0823160e01b81523060048201526001600160a01b0391909116906370a0823190602401602060405180830381865afa15801561050c573d5f803e3d5ffd5b505050506040513d601f19601f820116820180604052508101906105309190611dfe565b905090565b7f52c63247e1f47db19d5ce0460030c497f067ca4cebf71ba98eeadabe20bace0380546060915f805160206121b38339815191529161057390611e15565b80601f016020809104026020016040519081016040528092919081815260200182805461059f90611e15565b80156105ea5780601f106105c1576101008083540402835291602001916105ea565b820191905f5260205f20905b8154815290600101906020018083116105cd57829003601f168201915b505050505091505090565b5f610600825f610d33565b92915050565b5f33610613818585610d8b565b5060019392505050565b5f610600826001610d9d565b5f33610636858285610dec565b610641858585610e3d565b60019150505b9392505050565b5f807f0773e532dfede91f04b12a73d3d2acd361424f41f76b4fb79f090161e36b4e0090506006815461068b9190600160a01b900460ff16611e61565b91505090565b5f807f0773e532dfede91f04b12a73d3d2acd361424f41f76b4fb79f090161e36b4e005b546001600160a01b031692915050565b6106cd610e9a565b6106d5610ecc565b565b5f6106f05f805160206121d38339815191525460ff1690565b806106fd575060015460ff165b1561070957505f919050565b505f19919050565b5f61071a610f2b565b6107248383610f46565b905061060060015f805160206121f383398151915255565b6001600160a01b03165f9081525f805160206121b3833981519152602052604090205490565b60405162461bcd60e51b815260206004820152601f60248201527f4167656e745661756c74436f72653a2063616e6e6f742072656e6f756e63650060448201526064015b60405180910390fd5b6107b7610e9a565b6106d5610f9a565b5f807f9016d09d72d40fdae2fd8ceac6b6234c7706214fd39c1cd1e609a0528c1993006106b5565b5f6107f0610f2b565b6107248383610fe2565b7f52c63247e1f47db19d5ce0460030c497f067ca4cebf71ba98eeadabe20bace0480546060915f805160206121b38339815191529161057390611e15565b5f33610613818585610e3d565b5f610600826001610d33565b5f61085a610f2b565b61086584848461102e565b905061064760015f805160206121f383398151915255565b5f610886610f2b565b610865848484611084565b5f610600825f610d9d565b5f61060061027383610ae5565b5f6108b26110d1565b805490915060ff600160401b820416159067ffffffffffffffff165f811580156108d95750825b90505f8267ffffffffffffffff1660011480156108f55750303b155b905081158015610903575080155b156109215760405163f92ee8a960e01b815260040160405180910390fd5b845467ffffffffffffffff19166001178555831561094b57845460ff60401b1916600160401b1785555b60608060208a0135156109b9576109658a602001356110f9565b6040516020016109759190611e91565b60405160208183030381529060405291506109938a602001356110f9565b6040516020016109a39190611eb1565b60405160208183030381529060405290506109fc565b6040518060400160405280600a8152602001691059d95b9d15985d5b1d60b21b81525091506040518060400160405280600281526020016130ab60f11b81525090505b610a068282611189565b610a1b610a1660208c018c611ce1565b61119f565b610a24336111b0565b610a2c6111c1565b60208a01355f55610a4360a08b0160808c01611ed4565b600180546001600160a81b031916911515610100600160a81b031916919091176101006001600160a01b038c81169190910291909117909155600280546001600160a01b031916918a1691909117905550508315610adb57845460ff60401b19168555604051600181527fc7f505b2f371ae2175ee4913f4499e1f2633a7b5936321eed1cdaeb6115181d29060200160405180910390a15b5050505050505050565b5f6106008261073c565b6001600160a01b039182165f9081527f52c63247e1f47db19d5ce0460030c497f067ca4cebf71ba98eeadabe20bace016020908152604080832093909416825291909152205490565b5f610b41610f2b565b610b496111c9565b6001546040516312bf0dd360e21b8152600481018590526101009091046001600160a01b031690634afc374c90602401602060405180830381865afa158015610b94573d5f803e3d5ffd5b505050506040513d601f19601f82011682018060405250810190610bb89190611eef565b610bd55760405163bebdc75760e01b815260040160405180910390fd5b6001546040516233950960e01b8152600481018590525f9161010090046001600160a01b0316906233950990602401602060405180830381865afa158015610c1f573d5f803e3d5ffd5b505050506040513d601f19601f82011682018060405250810190610c439190611f0a565b9050336001600160a01b03821614610c6d576040516249a9c760e91b815260040160405180910390fd5b610c7683610891565b9150815f03610c9857604051639811e0c760e01b815260040160405180910390fd5b610ca4818285856111f9565b604080518481526020810184905285917f1270b999e194917a3d8d6bfd14138b9ea646c97e2c7654646f29819e53f62a62910160405180910390a25061060060015f805160206121f383398151915255565b610cfe610e9a565b6001600160a01b038116610d2757604051631e4fbdf760e01b81525f60048201526024016107a6565b610d3081611245565b50565b5f610647610d3f6104bf565b610d4a906001611f25565b610d566006600a61201b565b7f52c63247e1f47db19d5ce0460030c497f067ca4cebf71ba98eeadabe20bace0254610d829190611f25565b859190856112b5565b610d9883838360016112f7565b505050565b5f610647610dad6006600a61201b565b7f52c63247e1f47db19d5ce0460030c497f067ca4cebf71ba98eeadabe20bace0254610dd99190611f25565b610de16104bf565b610d82906001611f25565b5f610df78484610aef565b90505f19811015610e375781811015610e2957828183604051637dc7a0d960e11b81526004016107a693929190612029565b610e3784848484035f6112f7565b50505050565b6001600160a01b038316610e6657604051634b637e8f60e11b81525f60048201526024016107a6565b6001600160a01b038216610e8f5760405163ec442f0560e01b81525f60048201526024016107a6565b610d988383836113db565b33610ea36107bf565b6001600160a01b0316146106d55760405163118cdaa760e01b81523360048201526024016107a6565b610ed4611501565b5f805160206121d3833981519152805460ff191681557f5db9ee0a495bf2e6ff9c91a7834c1ba4fdd244a5e8aa4e537bd38aeae4b073aa335b6040516001600160a01b03909116815260200160405180910390a150565b610f33611530565b60025f805160206121f383398151915255565b5f80610f51836106d7565b905080841115610f7a57828482604051633c8097d960e11b81526004016107a693929190612029565b5f610f8485610891565b9050610f92338587846111f9565b949350505050565b610fa26111c9565b5f805160206121d3833981519152805460ff191660011781557f62e78cea01bee320cd4e420270b5ea74000d11b0c9f74754ebdbfc544b05a25833610f0d565b5f80610fed836106d7565b9050808411156110165782848260405163284ff66760e01b81526004016107a693929190612029565b5f61102085610845565b9050610f92338583886111f9565b5f806110398361089c565b90508085111561106257828582604051633fa733bb60e21b81526004016107a693929190612029565b5f61106c8661061d565b905061107b338686898561155f565b95945050505050565b5f8061108f83610ae5565b9050808511156110b857828582604051632e52afbb60e21b81526004016107a693929190612029565b5f6110c2866105f5565b905061107b338686848a61155f565b5f807ff0c57e16840df040f15088dc2f81fe391c3923bec73e23a9662efc9c229c6a00610600565b60605f611105836115ac565b60010190505f8167ffffffffffffffff8111156111245761112461204a565b6040519080825280601f01601f19166020018201604052801561114e576020820181803683370190505b5090508181016020015b5f19016f181899199a1a9b1b9c1cb0b131b232b360811b600a86061a8153600a850494508461115857509392505050565b611191611683565b61119b82826116a8565b5050565b6111a7611683565b610d30816116f8565b6111b8611683565b610d308161177b565b6106d5611683565b5f805160206121d38339815191525460ff16156106d55760405163d93c066560e01b815260040160405180910390fd5b815f0361121957604051630cb65c7760e21b815260040160405180910390fd5b805f0361123957604051639811e0c760e01b815260040160405180910390fd5b610e3784848484611783565b7f9016d09d72d40fdae2fd8ceac6b6234c7706214fd39c1cd1e609a0528c19930080546001600160a01b031981166001600160a01b03848116918217845560405192169182907f8be0079c531659141344cd1fd0a4f28419497f9722a3daafe3b4186f6b6457e0905f90a3505050565b5f6112e26112c2836117e5565b80156112dd57505f84806112d8576112d861205e565b868809115b151590565b6112ed868686611811565b61107b9190611f25565b5f805160206121b38339815191526001600160a01b03851661132e5760405163e602df0560e01b81525f60048201526024016107a6565b6001600160a01b03841661135757604051634a1406b160e11b81525f60048201526024016107a6565b6001600160a01b038086165f908152600183016020908152604080832093881683529290522083905581156113d457836001600160a01b0316856001600160a01b03167f8c5be1e5ebec7d5bd14f71427d1e84f3dd0314c0f7b2291e5b200ac8c7c3b925856040516113cb91815260200190565b60405180910390a35b5050505050565b5f805160206121b38339815191526001600160a01b0384166114155781816002015f82825461140a9190611f25565b909155506114729050565b6001600160a01b0384165f90815260208290526040902054828110156114545784818460405163391434e360e21b81526004016107a693929190612029565b6001600160a01b0385165f9081526020839052604090209083900390555b6001600160a01b0383166114905760028101805483900390556114ae565b6001600160a01b0383165f9081526020829052604090208054830190555b826001600160a01b0316846001600160a01b03167fddf252ad1be2c89b69c2b068fc378daa952ba7f163c4a11628f55a4df523b3ef846040516114f391815260200190565b60405180910390a350505050565b5f805160206121d38339815191525460ff166106d557604051638dfc202b60e01b815260040160405180910390fd5b5f805160206121f3833981519152546002036106d557604051633ee5aeb560e01b815260040160405180910390fd5b815f0361157f57604051630cb65c7760e21b815260040160405180910390fd5b805f0361159f57604051639811e0c760e01b815260040160405180910390fd5b6113d485858585856118c1565b5f8072184f03e93ff9f4daa797ed6e38ed64bf6a1f0160401b83106115ea5772184f03e93ff9f4daa797ed6e38ed64bf6a1f0160401b830492506040015b6d04ee2d6d415b85acef81000000008310611616576d04ee2d6d415b85acef8100000000830492506020015b662386f26fc10000831061163457662386f26fc10000830492506010015b6305f5e100831061164c576305f5e100830492506008015b612710831061166057612710830492506004015b60648310611672576064830492506002015b600a83106106005760010192915050565b61168b611960565b6106d557604051631afcd79f60e31b815260040160405180910390fd5b6116b0611683565b5f805160206121b38339815191527f52c63247e1f47db19d5ce0460030c497f067ca4cebf71ba98eeadabe20bace036116e984826120b6565b5060048101610e3783826120b6565b611700611683565b7f0773e532dfede91f04b12a73d3d2acd361424f41f76b4fb79f090161e36b4e005f8061172c84611979565b915091508161173c57601261173e565b805b83546001600160a81b031916600160a01b60ff92909216919091026001600160a01b031916176001600160a01b0394909416939093179091555050565b610cfe611683565b61178d8483611a04565b6117978382611a17565b826001600160a01b0316846001600160a01b03167fdcbc1c05240f31ff3ad067ef1ee35ce4997762752e3a095284754544f4c709d784846040516114f3929190918252602082015260400190565b5f60028260038111156117fa576117fa612171565b6118049190612185565b60ff166001149050919050565b5f805f61181e8686611a4b565b91509150815f03611842578381816118385761183861205e565b0492505050610647565b818411611859576118596003851502601118611a67565b5f848688095f868103871696879004966002600389028118808a02820302808a02820302808a02820302808a02820302808a02820302808a02909103029181900381900460010185841190960395909502919093039390930492909217029150509392505050565b826001600160a01b0316856001600160a01b0316146118e5576118e5838683610dec565b6118ef8382611a78565b6118f98483611aac565b826001600160a01b0316846001600160a01b0316866001600160a01b03167ffbde797d201c681b91056529119e0b02407c7bb96a4a2c75c01fc9667232c8db8585604051611951929190918252602082015260400190565b60405180910390a45050505050565b5f6119696110d1565b54600160401b900460ff16919050565b5f805f61198560405190565b6040805160048152602481019091526020810180516001600160e01b031663313ce56760e01b1790529091505f9081906119c0908790611abe565b50915091506119ce83604052565b8180156119dc575060203d10155b80156119e9575060ff8111155b6119f4575f806119f8565b6001815b94509450505050915091565b61119b611a0f610691565b833084611adf565b6001600160a01b038216611a405760405163ec442f0560e01b81525f60048201526024016107a6565b61119b5f83836113db565b5f805f1983850993909202808410938190039390930393915050565b634e487b715f52806020526024601cfd5b6001600160a01b038216611aa157604051634b637e8f60e11b81525f60048201526024016107a6565b61119b825f836113db565b61119b611ab7610691565b8383611b15565b5f805f60405f855160208701885afa92505f51915060205190509250925092565b611aed848484846001611b4a565b610e3757604051635274afe760e01b81526001600160a01b03851660048201526024016107a6565b611b228383836001611bb7565b610d9857604051635274afe760e01b81526001600160a01b03841660048201526024016107a6565b6040516323b872dd60e01b5f8181526001600160a01b038781166004528616602452604485905291602083606481808c5af1925060015f51148316611ba6578383151615611b9a573d5f823e3d81fd5b5f883b113d1516831692505b604052505f60605295945050505050565b60405163a9059cbb60e01b5f8181526001600160a01b038616600452602485905291602083604481808b5af1925060015f51148316611c0d578383151615611c01573d5f823e3d81fd5b5f873b113d1516831692505b60405250949350505050565b602081525f82518060208401528060208501604085015e5f604082850101526040601f19601f83011684010191505092915050565b5f60208284031215611c5e575f80fd5b5035919050565b6001600160a01b0381168114610d30575f80fd5b5f8060408385031215611c8a575f80fd5b8235611c9581611c65565b946020939093013593505050565b5f805f60608486031215611cb5575f80fd5b8335611cc081611c65565b92506020840135611cd081611c65565b929592945050506040919091013590565b5f60208284031215611cf1575f80fd5b813561064781611c65565b5f8060408385031215611d0d575f80fd5b823591506020830135611d1f81611c65565b809150509250929050565b5f805f60608486031215611d3c575f80fd5b833592506020840135611d4e81611c65565b91506040840135611d5e81611c65565b809150509250925092565b5f805f60608486031215611d7b575f80fd5b833567ffffffffffffffff811115611d91575f80fd5b840160e08187031215611da2575f80fd5b92506020840135611d4e81611c65565b5f8060408385031215611dc3575f80fd5b8235611dce81611c65565b91506020830135611d1f81611c65565b5f8060408385031215611def575f80fd5b50508035926020909101359150565b5f60208284031215611e0e575f80fd5b5051919050565b600181811c90821680611e2957607f821691505b602082108103611e4757634e487b7160e01b5f52602260045260245ffd5b50919050565b634e487b7160e01b5f52601160045260245ffd5b60ff818116838216019081111561060057610600611e4d565b5f81518060208401855e5f93019283525090919050565b6b4167656e745661756c74202360a01b81525f610647600c830184611e7a565b6130ab60f11b81525f6106476002830184611e7a565b8015158114610d30575f80fd5b5f60208284031215611ee4575f80fd5b813561064781611ec7565b5f60208284031215611eff575f80fd5b815161064781611ec7565b5f60208284031215611f1a575f80fd5b815161064781611c65565b8082018082111561060057610600611e4d565b6001815b6001841115611f7357808504811115611f5757611f57611e4d565b6001841615611f6557908102905b60019390931c928002611f3c565b935093915050565b5f82611f8957506001610600565b81611f9557505f610600565b8160018114611fab5760028114611fb557611fd1565b6001915050610600565b60ff841115611fc657611fc6611e4d565b50506001821b610600565b5060208310610133831016604e8410600b8410161715611ff4575081810a610600565b6120005f198484611f38565b805f190482111561201357612013611e4d565b029392505050565b5f61064760ff841683611f7b565b6001600160a01b039390931683526020830191909152604082015260600190565b634e487b7160e01b5f52604160045260245ffd5b634e487b7160e01b5f52601260045260245ffd5b601f821115610d9857805f5260205f20601f840160051c810160208510156120975750805b601f840160051c820191505b818110156113d4575f81556001016120a3565b815167ffffffffffffffff8111156120d0576120d061204a565b6120e4816120de8454611e15565b84612072565b6020601f821160018114612116575f83156120ff5750848201515b5f19600385901b1c1916600184901b1784556113d4565b5f84815260208120601f198516915b828110156121455787850151825560209485019460019092019101612125565b508482101561216257868401515f19600387901b60f8161c191681555b50505050600190811b01905550565b634e487b7160e01b5f52602160045260245ffd5b5f60ff8316806121a357634e487b7160e01b5f52601260045260245ffd5b8060ff8416069150509291505056fe52c63247e1f47db19d5ce0460030c497f067ca4cebf71ba98eeadabe20bace00cd5ed15c6e187e77e9aee88184c21f4f2182ab5827cb3b7e07fbedcd63f033009b779b17422d0df92223018b32b4d1fa46e071723d6817e2486d003becc55f00a264697066735822122076172941fe0551a70bb670272a940f4acb511f6af1171f877d78047a60b9fbb564736f6c634300081a0033" as const;
